
import React from 'react';
import { ReactComponent as SparkIcon } from 'Images/spark_icon.svg';

import PromptCopyCard from '../PromptCopyCard';

import {
  Wrapper,
  IntroText
} from './styled';

const VerifyConnectionSection = () => {
  const prompt = '"List my Faraday workspaces"';

  return (
    <Wrapper>
      <IntroText>Once connected, test with this prompt.</IntroText>
      <PromptCopyCard
        text={ prompt }
        copyValue={ prompt }
        leadingIcon={ <SparkIcon /> }
      />
    </Wrapper>
  );
};

export default VerifyConnectionSection;
